/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as UserSettingsRouteImport } from './routes/user-settings';
import { Route as UploadRouteImport } from './routes/upload';
import { Route as PreparerRouteImport } from './routes/preparer';
import { Route as NotificationSettingsRouteImport } from './routes/notification-settings';
import { Route as LoginRouteImport } from './routes/login';
import { Route as DashboardRouteImport } from './routes/dashboard';
import { Route as ContactInfoRouteImport } from './routes/contact-info';
import { Route as ClientSelectRouteImport } from './routes/client-select';
import { Route as IndexRouteImport } from './routes/index';
import { Route as TaxBindersIndexRouteImport } from './routes/tax-binders/index';
import { Route as PreparerIndexRouteImport } from './routes/preparer.index';
import { Route as BindersIndexRouteImport } from './routes/binders/index';
import { Route as UploadIdRouteImport } from './routes/upload_.$id';
import { Route as TaxBindersBinderIdRouteImport } from './routes/tax-binders/$binderId';
import { Route as SharedDocumentTokenRouteImport } from './routes/shared-document/$token';
import { Route as PreparerUsersRouteImport } from './routes/preparer/users';
import { Route as PreparerNotificationSettingsRouteImport } from './routes/preparer/notification-settings';
import { Route as PreparerLoginRouteImport } from './routes/preparer.login';
import { Route as PreparerClientsRouteImport } from './routes/preparer/clients';
import { Route as PreparerAuditLogsRouteImport } from './routes/preparer/audit-logs';
import { Route as PreparerAuditDashboardRouteImport } from './routes/preparer/audit-dashboard';
import { Route as PreparerAdminDashboardRouteImport } from './routes/preparer/admin-dashboard';
import { Route as BindersSplatRouteImport } from './routes/binders/$';
import { Route as TaxBindersBinderIdIndexRouteImport } from './routes/tax-binders/$binderId.index';
import { Route as PreparerUsersIndexRouteImport } from './routes/preparer/users/index';
import { Route as PreparerTaxBindersIndexRouteImport } from './routes/preparer/tax-binders/index';
import { Route as PreparerSignatureTemplatesIndexRouteImport } from './routes/preparer/signature-templates/index';
import { Route as PreparerSentDocumentsIndexRouteImport } from './routes/preparer/sent-documents/index';
import { Route as PreparerNotificationsIndexRouteImport } from './routes/preparer/notifications/index';
import { Route as PreparerClientsIndexRouteImport } from './routes/preparer/clients/index';
import { Route as PreparerBindersIndexRouteImport } from './routes/preparer/binders/index';
import { Route as PreparerAuditBindersIndexRouteImport } from './routes/preparer/audit-binders/index';
import { Route as PreparerAccessRequestsIndexRouteImport } from './routes/preparer/access-requests/index';
import { Route as AuditBindersBinderIdIndexRouteImport } from './routes/audit-binders/$binderId/index';
import { Route as TaxBindersBinderIdSignReturnsRouteImport } from './routes/tax-binders/$binderId.sign-returns';
import { Route as TaxBindersBinderIdReturnsRouteImport } from './routes/tax-binders/$binderId.returns';
import { Route as TaxBindersBinderIdQuestionnaireRouteImport } from './routes/tax-binders/$binderId.questionnaire';
import { Route as TaxBindersBinderIdEngagementLetterRouteImport } from './routes/tax-binders/$binderId.engagement-letter';
import { Route as TaxBindersBinderIdEfileAuthorizationRouteImport } from './routes/tax-binders/$binderId.efile-authorization';
import { Route as TaxBindersBinderIdDocumentsRouteImport } from './routes/tax-binders/$binderId.documents';
import { Route as TaxBindersBinderIdCommunicationsRouteImport } from './routes/tax-binders/$binderId.communications';
import { Route as PreparerUsersUserIdRouteImport } from './routes/preparer/users/$userId';
import { Route as PreparerTaxBindersBinderIdRouteImport } from './routes/preparer/tax-binders/$binderId';
import { Route as PreparerClientsClientIdRouteImport } from './routes/preparer/clients/$clientId';
import { Route as PreparerBindersSplatRouteImport } from './routes/preparer/binders/$';
import { Route as PreparerAuditBindersBinderIdRouteImport } from './routes/preparer/audit-binders/$binderId';
import { Route as AuthSsoCallbackRouteImport } from './routes/auth/sso/callback';
import { Route as PreparerTaxBindersBinderIdAuditLogsRouteImport } from './routes/preparer/tax-binders/$binderId.audit-logs';
import { Route as PreparerSignatureTemplatesPreviewTemplateIdRouteImport } from './routes/preparer/signature-templates/preview/$templateId';
import { Route as PreparerSignatureTemplatesEditTemplateIdRouteImport } from './routes/preparer/signature-templates/edit/$templateId';
import { Route as PreparerClientsClientIdAuditLogsRouteImport } from './routes/preparer/clients/$clientId/audit-logs';
import { Route as PreparerBinderBinderIdAuditLogsRouteImport } from './routes/preparer/binder/$binderId/audit-logs';
import { Route as AuditBindersBinderIdItemsItemIdRouteImport } from './routes/audit-binders/$binderId/items/$itemId';
import { Route as PreparerTaxBindersBinderIdDocumentRequestRequestIdRouteImport } from './routes/preparer/tax-binders/$binderId.document-request.$requestId';

const UserSettingsRoute = UserSettingsRouteImport.update({
  id: '/user-settings',
  path: '/user-settings',
  getParentRoute: () => rootRouteImport,
} as any);
const UploadRoute = UploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => rootRouteImport,
} as any);
const PreparerRoute = PreparerRouteImport.update({
  id: '/preparer',
  path: '/preparer',
  getParentRoute: () => rootRouteImport,
} as any);
const NotificationSettingsRoute = NotificationSettingsRouteImport.update({
  id: '/notification-settings',
  path: '/notification-settings',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any);
const ContactInfoRoute = ContactInfoRouteImport.update({
  id: '/contact-info',
  path: '/contact-info',
  getParentRoute: () => rootRouteImport,
} as any);
const ClientSelectRoute = ClientSelectRouteImport.update({
  id: '/client-select',
  path: '/client-select',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const TaxBindersIndexRoute = TaxBindersIndexRouteImport.update({
  id: '/tax-binders/',
  path: '/tax-binders/',
  getParentRoute: () => rootRouteImport,
} as any);
const PreparerIndexRoute = PreparerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PreparerRoute,
} as any);
const BindersIndexRoute = BindersIndexRouteImport.update({
  id: '/binders/',
  path: '/binders/',
  getParentRoute: () => rootRouteImport,
} as any);
const UploadIdRoute = UploadIdRouteImport.update({
  id: '/upload_/$id',
  path: '/upload/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const TaxBindersBinderIdRoute = TaxBindersBinderIdRouteImport.update({
  id: '/tax-binders/$binderId',
  path: '/tax-binders/$binderId',
  getParentRoute: () => rootRouteImport,
} as any);
const SharedDocumentTokenRoute = SharedDocumentTokenRouteImport.update({
  id: '/shared-document/$token',
  path: '/shared-document/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const PreparerUsersRoute = PreparerUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => PreparerRoute,
} as any);
const PreparerNotificationSettingsRoute =
  PreparerNotificationSettingsRouteImport.update({
    id: '/notification-settings',
    path: '/notification-settings',
    getParentRoute: () => PreparerRoute,
  } as any);
const PreparerLoginRoute = PreparerLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PreparerRoute,
} as any);
const PreparerClientsRoute = PreparerClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => PreparerRoute,
} as any);
const PreparerAuditLogsRoute = PreparerAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => PreparerRoute,
} as any);
const PreparerAuditDashboardRoute = PreparerAuditDashboardRouteImport.update({
  id: '/audit-dashboard',
  path: '/audit-dashboard',
  getParentRoute: () => PreparerRoute,
} as any);
const PreparerAdminDashboardRoute = PreparerAdminDashboardRouteImport.update({
  id: '/admin-dashboard',
  path: '/admin-dashboard',
  getParentRoute: () => PreparerRoute,
} as any);
const BindersSplatRoute = BindersSplatRouteImport.update({
  id: '/binders/$',
  path: '/binders/$',
  getParentRoute: () => rootRouteImport,
} as any);
const TaxBindersBinderIdIndexRoute = TaxBindersBinderIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TaxBindersBinderIdRoute,
} as any);
const PreparerUsersIndexRoute = PreparerUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PreparerUsersRoute,
} as any);
const PreparerTaxBindersIndexRoute = PreparerTaxBindersIndexRouteImport.update({
  id: '/tax-binders/',
  path: '/tax-binders/',
  getParentRoute: () => PreparerRoute,
} as any);
const PreparerSignatureTemplatesIndexRoute =
  PreparerSignatureTemplatesIndexRouteImport.update({
    id: '/signature-templates/',
    path: '/signature-templates/',
    getParentRoute: () => PreparerRoute,
  } as any);
const PreparerSentDocumentsIndexRoute =
  PreparerSentDocumentsIndexRouteImport.update({
    id: '/sent-documents/',
    path: '/sent-documents/',
    getParentRoute: () => PreparerRoute,
  } as any);
const PreparerNotificationsIndexRoute =
  PreparerNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => PreparerRoute,
  } as any);
const PreparerClientsIndexRoute = PreparerClientsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PreparerClientsRoute,
} as any);
const PreparerBindersIndexRoute = PreparerBindersIndexRouteImport.update({
  id: '/binders/',
  path: '/binders/',
  getParentRoute: () => PreparerRoute,
} as any);
const PreparerAuditBindersIndexRoute =
  PreparerAuditBindersIndexRouteImport.update({
    id: '/audit-binders/',
    path: '/audit-binders/',
    getParentRoute: () => PreparerRoute,
  } as any);
const PreparerAccessRequestsIndexRoute =
  PreparerAccessRequestsIndexRouteImport.update({
    id: '/access-requests/',
    path: '/access-requests/',
    getParentRoute: () => PreparerRoute,
  } as any);
const AuditBindersBinderIdIndexRoute =
  AuditBindersBinderIdIndexRouteImport.update({
    id: '/audit-binders/$binderId/',
    path: '/audit-binders/$binderId/',
    getParentRoute: () => rootRouteImport,
  } as any);
const TaxBindersBinderIdSignReturnsRoute =
  TaxBindersBinderIdSignReturnsRouteImport.update({
    id: '/sign-returns',
    path: '/sign-returns',
    getParentRoute: () => TaxBindersBinderIdRoute,
  } as any);
const TaxBindersBinderIdReturnsRoute =
  TaxBindersBinderIdReturnsRouteImport.update({
    id: '/returns',
    path: '/returns',
    getParentRoute: () => TaxBindersBinderIdRoute,
  } as any);
const TaxBindersBinderIdQuestionnaireRoute =
  TaxBindersBinderIdQuestionnaireRouteImport.update({
    id: '/questionnaire',
    path: '/questionnaire',
    getParentRoute: () => TaxBindersBinderIdRoute,
  } as any);
const TaxBindersBinderIdEngagementLetterRoute =
  TaxBindersBinderIdEngagementLetterRouteImport.update({
    id: '/engagement-letter',
    path: '/engagement-letter',
    getParentRoute: () => TaxBindersBinderIdRoute,
  } as any);
const TaxBindersBinderIdEfileAuthorizationRoute =
  TaxBindersBinderIdEfileAuthorizationRouteImport.update({
    id: '/efile-authorization',
    path: '/efile-authorization',
    getParentRoute: () => TaxBindersBinderIdRoute,
  } as any);
const TaxBindersBinderIdDocumentsRoute =
  TaxBindersBinderIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => TaxBindersBinderIdRoute,
  } as any);
const TaxBindersBinderIdCommunicationsRoute =
  TaxBindersBinderIdCommunicationsRouteImport.update({
    id: '/communications',
    path: '/communications',
    getParentRoute: () => TaxBindersBinderIdRoute,
  } as any);
const PreparerUsersUserIdRoute = PreparerUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => PreparerUsersRoute,
} as any);
const PreparerTaxBindersBinderIdRoute =
  PreparerTaxBindersBinderIdRouteImport.update({
    id: '/tax-binders/$binderId',
    path: '/tax-binders/$binderId',
    getParentRoute: () => PreparerRoute,
  } as any);
const PreparerClientsClientIdRoute = PreparerClientsClientIdRouteImport.update({
  id: '/$clientId',
  path: '/$clientId',
  getParentRoute: () => PreparerClientsRoute,
} as any);
const PreparerBindersSplatRoute = PreparerBindersSplatRouteImport.update({
  id: '/binders/$',
  path: '/binders/$',
  getParentRoute: () => PreparerRoute,
} as any);
const PreparerAuditBindersBinderIdRoute =
  PreparerAuditBindersBinderIdRouteImport.update({
    id: '/audit-binders/$binderId',
    path: '/audit-binders/$binderId',
    getParentRoute: () => PreparerRoute,
  } as any);
const AuthSsoCallbackRoute = AuthSsoCallbackRouteImport.update({
  id: '/auth/sso/callback',
  path: '/auth/sso/callback',
  getParentRoute: () => rootRouteImport,
} as any);
const PreparerTaxBindersBinderIdAuditLogsRoute =
  PreparerTaxBindersBinderIdAuditLogsRouteImport.update({
    id: '/audit-logs',
    path: '/audit-logs',
    getParentRoute: () => PreparerTaxBindersBinderIdRoute,
  } as any);
const PreparerSignatureTemplatesPreviewTemplateIdRoute =
  PreparerSignatureTemplatesPreviewTemplateIdRouteImport.update({
    id: '/signature-templates/preview/$templateId',
    path: '/signature-templates/preview/$templateId',
    getParentRoute: () => PreparerRoute,
  } as any);
const PreparerSignatureTemplatesEditTemplateIdRoute =
  PreparerSignatureTemplatesEditTemplateIdRouteImport.update({
    id: '/signature-templates/edit/$templateId',
    path: '/signature-templates/edit/$templateId',
    getParentRoute: () => PreparerRoute,
  } as any);
const PreparerClientsClientIdAuditLogsRoute =
  PreparerClientsClientIdAuditLogsRouteImport.update({
    id: '/audit-logs',
    path: '/audit-logs',
    getParentRoute: () => PreparerClientsClientIdRoute,
  } as any);
const PreparerBinderBinderIdAuditLogsRoute =
  PreparerBinderBinderIdAuditLogsRouteImport.update({
    id: '/binder/$binderId/audit-logs',
    path: '/binder/$binderId/audit-logs',
    getParentRoute: () => PreparerRoute,
  } as any);
const AuditBindersBinderIdItemsItemIdRoute =
  AuditBindersBinderIdItemsItemIdRouteImport.update({
    id: '/audit-binders/$binderId/items/$itemId',
    path: '/audit-binders/$binderId/items/$itemId',
    getParentRoute: () => rootRouteImport,
  } as any);
const PreparerTaxBindersBinderIdDocumentRequestRequestIdRoute =
  PreparerTaxBindersBinderIdDocumentRequestRequestIdRouteImport.update({
    id: '/document-request/$requestId',
    path: '/document-request/$requestId',
    getParentRoute: () => PreparerTaxBindersBinderIdRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/client-select': typeof ClientSelectRoute;
  '/contact-info': typeof ContactInfoRoute;
  '/dashboard': typeof DashboardRoute;
  '/login': typeof LoginRoute;
  '/notification-settings': typeof NotificationSettingsRoute;
  '/preparer': typeof PreparerRouteWithChildren;
  '/upload': typeof UploadRoute;
  '/user-settings': typeof UserSettingsRoute;
  '/binders/$': typeof BindersSplatRoute;
  '/preparer/admin-dashboard': typeof PreparerAdminDashboardRoute;
  '/preparer/audit-dashboard': typeof PreparerAuditDashboardRoute;
  '/preparer/audit-logs': typeof PreparerAuditLogsRoute;
  '/preparer/clients': typeof PreparerClientsRouteWithChildren;
  '/preparer/login': typeof PreparerLoginRoute;
  '/preparer/notification-settings': typeof PreparerNotificationSettingsRoute;
  '/preparer/users': typeof PreparerUsersRouteWithChildren;
  '/shared-document/$token': typeof SharedDocumentTokenRoute;
  '/tax-binders/$binderId': typeof TaxBindersBinderIdRouteWithChildren;
  '/upload/$id': typeof UploadIdRoute;
  '/binders/': typeof BindersIndexRoute;
  '/preparer/': typeof PreparerIndexRoute;
  '/tax-binders/': typeof TaxBindersIndexRoute;
  '/auth/sso/callback': typeof AuthSsoCallbackRoute;
  '/preparer/audit-binders/$binderId': typeof PreparerAuditBindersBinderIdRoute;
  '/preparer/binders/$': typeof PreparerBindersSplatRoute;
  '/preparer/clients/$clientId': typeof PreparerClientsClientIdRouteWithChildren;
  '/preparer/tax-binders/$binderId': typeof PreparerTaxBindersBinderIdRouteWithChildren;
  '/preparer/users/$userId': typeof PreparerUsersUserIdRoute;
  '/tax-binders/$binderId/communications': typeof TaxBindersBinderIdCommunicationsRoute;
  '/tax-binders/$binderId/documents': typeof TaxBindersBinderIdDocumentsRoute;
  '/tax-binders/$binderId/efile-authorization': typeof TaxBindersBinderIdEfileAuthorizationRoute;
  '/tax-binders/$binderId/engagement-letter': typeof TaxBindersBinderIdEngagementLetterRoute;
  '/tax-binders/$binderId/questionnaire': typeof TaxBindersBinderIdQuestionnaireRoute;
  '/tax-binders/$binderId/returns': typeof TaxBindersBinderIdReturnsRoute;
  '/tax-binders/$binderId/sign-returns': typeof TaxBindersBinderIdSignReturnsRoute;
  '/audit-binders/$binderId/': typeof AuditBindersBinderIdIndexRoute;
  '/preparer/access-requests/': typeof PreparerAccessRequestsIndexRoute;
  '/preparer/audit-binders/': typeof PreparerAuditBindersIndexRoute;
  '/preparer/binders/': typeof PreparerBindersIndexRoute;
  '/preparer/clients/': typeof PreparerClientsIndexRoute;
  '/preparer/notifications/': typeof PreparerNotificationsIndexRoute;
  '/preparer/sent-documents/': typeof PreparerSentDocumentsIndexRoute;
  '/preparer/signature-templates/': typeof PreparerSignatureTemplatesIndexRoute;
  '/preparer/tax-binders/': typeof PreparerTaxBindersIndexRoute;
  '/preparer/users/': typeof PreparerUsersIndexRoute;
  '/tax-binders/$binderId/': typeof TaxBindersBinderIdIndexRoute;
  '/audit-binders/$binderId/items/$itemId': typeof AuditBindersBinderIdItemsItemIdRoute;
  '/preparer/binder/$binderId/audit-logs': typeof PreparerBinderBinderIdAuditLogsRoute;
  '/preparer/clients/$clientId/audit-logs': typeof PreparerClientsClientIdAuditLogsRoute;
  '/preparer/signature-templates/edit/$templateId': typeof PreparerSignatureTemplatesEditTemplateIdRoute;
  '/preparer/signature-templates/preview/$templateId': typeof PreparerSignatureTemplatesPreviewTemplateIdRoute;
  '/preparer/tax-binders/$binderId/audit-logs': typeof PreparerTaxBindersBinderIdAuditLogsRoute;
  '/preparer/tax-binders/$binderId/document-request/$requestId': typeof PreparerTaxBindersBinderIdDocumentRequestRequestIdRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/client-select': typeof ClientSelectRoute;
  '/contact-info': typeof ContactInfoRoute;
  '/dashboard': typeof DashboardRoute;
  '/login': typeof LoginRoute;
  '/notification-settings': typeof NotificationSettingsRoute;
  '/upload': typeof UploadRoute;
  '/user-settings': typeof UserSettingsRoute;
  '/binders/$': typeof BindersSplatRoute;
  '/preparer/admin-dashboard': typeof PreparerAdminDashboardRoute;
  '/preparer/audit-dashboard': typeof PreparerAuditDashboardRoute;
  '/preparer/audit-logs': typeof PreparerAuditLogsRoute;
  '/preparer/login': typeof PreparerLoginRoute;
  '/preparer/notification-settings': typeof PreparerNotificationSettingsRoute;
  '/shared-document/$token': typeof SharedDocumentTokenRoute;
  '/upload/$id': typeof UploadIdRoute;
  '/binders': typeof BindersIndexRoute;
  '/preparer': typeof PreparerIndexRoute;
  '/tax-binders': typeof TaxBindersIndexRoute;
  '/auth/sso/callback': typeof AuthSsoCallbackRoute;
  '/preparer/audit-binders/$binderId': typeof PreparerAuditBindersBinderIdRoute;
  '/preparer/binders/$': typeof PreparerBindersSplatRoute;
  '/preparer/clients/$clientId': typeof PreparerClientsClientIdRouteWithChildren;
  '/preparer/tax-binders/$binderId': typeof PreparerTaxBindersBinderIdRouteWithChildren;
  '/preparer/users/$userId': typeof PreparerUsersUserIdRoute;
  '/tax-binders/$binderId/communications': typeof TaxBindersBinderIdCommunicationsRoute;
  '/tax-binders/$binderId/documents': typeof TaxBindersBinderIdDocumentsRoute;
  '/tax-binders/$binderId/efile-authorization': typeof TaxBindersBinderIdEfileAuthorizationRoute;
  '/tax-binders/$binderId/engagement-letter': typeof TaxBindersBinderIdEngagementLetterRoute;
  '/tax-binders/$binderId/questionnaire': typeof TaxBindersBinderIdQuestionnaireRoute;
  '/tax-binders/$binderId/returns': typeof TaxBindersBinderIdReturnsRoute;
  '/tax-binders/$binderId/sign-returns': typeof TaxBindersBinderIdSignReturnsRoute;
  '/audit-binders/$binderId': typeof AuditBindersBinderIdIndexRoute;
  '/preparer/access-requests': typeof PreparerAccessRequestsIndexRoute;
  '/preparer/audit-binders': typeof PreparerAuditBindersIndexRoute;
  '/preparer/binders': typeof PreparerBindersIndexRoute;
  '/preparer/clients': typeof PreparerClientsIndexRoute;
  '/preparer/notifications': typeof PreparerNotificationsIndexRoute;
  '/preparer/sent-documents': typeof PreparerSentDocumentsIndexRoute;
  '/preparer/signature-templates': typeof PreparerSignatureTemplatesIndexRoute;
  '/preparer/tax-binders': typeof PreparerTaxBindersIndexRoute;
  '/preparer/users': typeof PreparerUsersIndexRoute;
  '/tax-binders/$binderId': typeof TaxBindersBinderIdIndexRoute;
  '/audit-binders/$binderId/items/$itemId': typeof AuditBindersBinderIdItemsItemIdRoute;
  '/preparer/binder/$binderId/audit-logs': typeof PreparerBinderBinderIdAuditLogsRoute;
  '/preparer/clients/$clientId/audit-logs': typeof PreparerClientsClientIdAuditLogsRoute;
  '/preparer/signature-templates/edit/$templateId': typeof PreparerSignatureTemplatesEditTemplateIdRoute;
  '/preparer/signature-templates/preview/$templateId': typeof PreparerSignatureTemplatesPreviewTemplateIdRoute;
  '/preparer/tax-binders/$binderId/audit-logs': typeof PreparerTaxBindersBinderIdAuditLogsRoute;
  '/preparer/tax-binders/$binderId/document-request/$requestId': typeof PreparerTaxBindersBinderIdDocumentRequestRequestIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/client-select': typeof ClientSelectRoute;
  '/contact-info': typeof ContactInfoRoute;
  '/dashboard': typeof DashboardRoute;
  '/login': typeof LoginRoute;
  '/notification-settings': typeof NotificationSettingsRoute;
  '/preparer': typeof PreparerRouteWithChildren;
  '/upload': typeof UploadRoute;
  '/user-settings': typeof UserSettingsRoute;
  '/binders/$': typeof BindersSplatRoute;
  '/preparer/admin-dashboard': typeof PreparerAdminDashboardRoute;
  '/preparer/audit-dashboard': typeof PreparerAuditDashboardRoute;
  '/preparer/audit-logs': typeof PreparerAuditLogsRoute;
  '/preparer/clients': typeof PreparerClientsRouteWithChildren;
  '/preparer/login': typeof PreparerLoginRoute;
  '/preparer/notification-settings': typeof PreparerNotificationSettingsRoute;
  '/preparer/users': typeof PreparerUsersRouteWithChildren;
  '/shared-document/$token': typeof SharedDocumentTokenRoute;
  '/tax-binders/$binderId': typeof TaxBindersBinderIdRouteWithChildren;
  '/upload_/$id': typeof UploadIdRoute;
  '/binders/': typeof BindersIndexRoute;
  '/preparer/': typeof PreparerIndexRoute;
  '/tax-binders/': typeof TaxBindersIndexRoute;
  '/auth/sso/callback': typeof AuthSsoCallbackRoute;
  '/preparer/audit-binders/$binderId': typeof PreparerAuditBindersBinderIdRoute;
  '/preparer/binders/$': typeof PreparerBindersSplatRoute;
  '/preparer/clients/$clientId': typeof PreparerClientsClientIdRouteWithChildren;
  '/preparer/tax-binders/$binderId': typeof PreparerTaxBindersBinderIdRouteWithChildren;
  '/preparer/users/$userId': typeof PreparerUsersUserIdRoute;
  '/tax-binders/$binderId/communications': typeof TaxBindersBinderIdCommunicationsRoute;
  '/tax-binders/$binderId/documents': typeof TaxBindersBinderIdDocumentsRoute;
  '/tax-binders/$binderId/efile-authorization': typeof TaxBindersBinderIdEfileAuthorizationRoute;
  '/tax-binders/$binderId/engagement-letter': typeof TaxBindersBinderIdEngagementLetterRoute;
  '/tax-binders/$binderId/questionnaire': typeof TaxBindersBinderIdQuestionnaireRoute;
  '/tax-binders/$binderId/returns': typeof TaxBindersBinderIdReturnsRoute;
  '/tax-binders/$binderId/sign-returns': typeof TaxBindersBinderIdSignReturnsRoute;
  '/audit-binders/$binderId/': typeof AuditBindersBinderIdIndexRoute;
  '/preparer/access-requests/': typeof PreparerAccessRequestsIndexRoute;
  '/preparer/audit-binders/': typeof PreparerAuditBindersIndexRoute;
  '/preparer/binders/': typeof PreparerBindersIndexRoute;
  '/preparer/clients/': typeof PreparerClientsIndexRoute;
  '/preparer/notifications/': typeof PreparerNotificationsIndexRoute;
  '/preparer/sent-documents/': typeof PreparerSentDocumentsIndexRoute;
  '/preparer/signature-templates/': typeof PreparerSignatureTemplatesIndexRoute;
  '/preparer/tax-binders/': typeof PreparerTaxBindersIndexRoute;
  '/preparer/users/': typeof PreparerUsersIndexRoute;
  '/tax-binders/$binderId/': typeof TaxBindersBinderIdIndexRoute;
  '/audit-binders/$binderId/items/$itemId': typeof AuditBindersBinderIdItemsItemIdRoute;
  '/preparer/binder/$binderId/audit-logs': typeof PreparerBinderBinderIdAuditLogsRoute;
  '/preparer/clients/$clientId/audit-logs': typeof PreparerClientsClientIdAuditLogsRoute;
  '/preparer/signature-templates/edit/$templateId': typeof PreparerSignatureTemplatesEditTemplateIdRoute;
  '/preparer/signature-templates/preview/$templateId': typeof PreparerSignatureTemplatesPreviewTemplateIdRoute;
  '/preparer/tax-binders/$binderId/audit-logs': typeof PreparerTaxBindersBinderIdAuditLogsRoute;
  '/preparer/tax-binders/$binderId/document-request/$requestId': typeof PreparerTaxBindersBinderIdDocumentRequestRequestIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/client-select'
    | '/contact-info'
    | '/dashboard'
    | '/login'
    | '/notification-settings'
    | '/preparer'
    | '/upload'
    | '/user-settings'
    | '/binders/$'
    | '/preparer/admin-dashboard'
    | '/preparer/audit-dashboard'
    | '/preparer/audit-logs'
    | '/preparer/clients'
    | '/preparer/login'
    | '/preparer/notification-settings'
    | '/preparer/users'
    | '/shared-document/$token'
    | '/tax-binders/$binderId'
    | '/upload/$id'
    | '/binders/'
    | '/preparer/'
    | '/tax-binders/'
    | '/auth/sso/callback'
    | '/preparer/audit-binders/$binderId'
    | '/preparer/binders/$'
    | '/preparer/clients/$clientId'
    | '/preparer/tax-binders/$binderId'
    | '/preparer/users/$userId'
    | '/tax-binders/$binderId/communications'
    | '/tax-binders/$binderId/documents'
    | '/tax-binders/$binderId/efile-authorization'
    | '/tax-binders/$binderId/engagement-letter'
    | '/tax-binders/$binderId/questionnaire'
    | '/tax-binders/$binderId/returns'
    | '/tax-binders/$binderId/sign-returns'
    | '/audit-binders/$binderId/'
    | '/preparer/access-requests/'
    | '/preparer/audit-binders/'
    | '/preparer/binders/'
    | '/preparer/clients/'
    | '/preparer/notifications/'
    | '/preparer/sent-documents/'
    | '/preparer/signature-templates/'
    | '/preparer/tax-binders/'
    | '/preparer/users/'
    | '/tax-binders/$binderId/'
    | '/audit-binders/$binderId/items/$itemId'
    | '/preparer/binder/$binderId/audit-logs'
    | '/preparer/clients/$clientId/audit-logs'
    | '/preparer/signature-templates/edit/$templateId'
    | '/preparer/signature-templates/preview/$templateId'
    | '/preparer/tax-binders/$binderId/audit-logs'
    | '/preparer/tax-binders/$binderId/document-request/$requestId';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/client-select'
    | '/contact-info'
    | '/dashboard'
    | '/login'
    | '/notification-settings'
    | '/upload'
    | '/user-settings'
    | '/binders/$'
    | '/preparer/admin-dashboard'
    | '/preparer/audit-dashboard'
    | '/preparer/audit-logs'
    | '/preparer/login'
    | '/preparer/notification-settings'
    | '/shared-document/$token'
    | '/upload/$id'
    | '/binders'
    | '/preparer'
    | '/tax-binders'
    | '/auth/sso/callback'
    | '/preparer/audit-binders/$binderId'
    | '/preparer/binders/$'
    | '/preparer/clients/$clientId'
    | '/preparer/tax-binders/$binderId'
    | '/preparer/users/$userId'
    | '/tax-binders/$binderId/communications'
    | '/tax-binders/$binderId/documents'
    | '/tax-binders/$binderId/efile-authorization'
    | '/tax-binders/$binderId/engagement-letter'
    | '/tax-binders/$binderId/questionnaire'
    | '/tax-binders/$binderId/returns'
    | '/tax-binders/$binderId/sign-returns'
    | '/audit-binders/$binderId'
    | '/preparer/access-requests'
    | '/preparer/audit-binders'
    | '/preparer/binders'
    | '/preparer/clients'
    | '/preparer/notifications'
    | '/preparer/sent-documents'
    | '/preparer/signature-templates'
    | '/preparer/tax-binders'
    | '/preparer/users'
    | '/tax-binders/$binderId'
    | '/audit-binders/$binderId/items/$itemId'
    | '/preparer/binder/$binderId/audit-logs'
    | '/preparer/clients/$clientId/audit-logs'
    | '/preparer/signature-templates/edit/$templateId'
    | '/preparer/signature-templates/preview/$templateId'
    | '/preparer/tax-binders/$binderId/audit-logs'
    | '/preparer/tax-binders/$binderId/document-request/$requestId';
  id:
    | '__root__'
    | '/'
    | '/client-select'
    | '/contact-info'
    | '/dashboard'
    | '/login'
    | '/notification-settings'
    | '/preparer'
    | '/upload'
    | '/user-settings'
    | '/binders/$'
    | '/preparer/admin-dashboard'
    | '/preparer/audit-dashboard'
    | '/preparer/audit-logs'
    | '/preparer/clients'
    | '/preparer/login'
    | '/preparer/notification-settings'
    | '/preparer/users'
    | '/shared-document/$token'
    | '/tax-binders/$binderId'
    | '/upload_/$id'
    | '/binders/'
    | '/preparer/'
    | '/tax-binders/'
    | '/auth/sso/callback'
    | '/preparer/audit-binders/$binderId'
    | '/preparer/binders/$'
    | '/preparer/clients/$clientId'
    | '/preparer/tax-binders/$binderId'
    | '/preparer/users/$userId'
    | '/tax-binders/$binderId/communications'
    | '/tax-binders/$binderId/documents'
    | '/tax-binders/$binderId/efile-authorization'
    | '/tax-binders/$binderId/engagement-letter'
    | '/tax-binders/$binderId/questionnaire'
    | '/tax-binders/$binderId/returns'
    | '/tax-binders/$binderId/sign-returns'
    | '/audit-binders/$binderId/'
    | '/preparer/access-requests/'
    | '/preparer/audit-binders/'
    | '/preparer/binders/'
    | '/preparer/clients/'
    | '/preparer/notifications/'
    | '/preparer/sent-documents/'
    | '/preparer/signature-templates/'
    | '/preparer/tax-binders/'
    | '/preparer/users/'
    | '/tax-binders/$binderId/'
    | '/audit-binders/$binderId/items/$itemId'
    | '/preparer/binder/$binderId/audit-logs'
    | '/preparer/clients/$clientId/audit-logs'
    | '/preparer/signature-templates/edit/$templateId'
    | '/preparer/signature-templates/preview/$templateId'
    | '/preparer/tax-binders/$binderId/audit-logs'
    | '/preparer/tax-binders/$binderId/document-request/$requestId';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  ClientSelectRoute: typeof ClientSelectRoute;
  ContactInfoRoute: typeof ContactInfoRoute;
  DashboardRoute: typeof DashboardRoute;
  LoginRoute: typeof LoginRoute;
  NotificationSettingsRoute: typeof NotificationSettingsRoute;
  PreparerRoute: typeof PreparerRouteWithChildren;
  UploadRoute: typeof UploadRoute;
  UserSettingsRoute: typeof UserSettingsRoute;
  BindersSplatRoute: typeof BindersSplatRoute;
  SharedDocumentTokenRoute: typeof SharedDocumentTokenRoute;
  TaxBindersBinderIdRoute: typeof TaxBindersBinderIdRouteWithChildren;
  UploadIdRoute: typeof UploadIdRoute;
  BindersIndexRoute: typeof BindersIndexRoute;
  TaxBindersIndexRoute: typeof TaxBindersIndexRoute;
  AuthSsoCallbackRoute: typeof AuthSsoCallbackRoute;
  AuditBindersBinderIdIndexRoute: typeof AuditBindersBinderIdIndexRoute;
  AuditBindersBinderIdItemsItemIdRoute: typeof AuditBindersBinderIdItemsItemIdRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/user-settings': {
      id: '/user-settings';
      path: '/user-settings';
      fullPath: '/user-settings';
      preLoaderRoute: typeof UserSettingsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/upload': {
      id: '/upload';
      path: '/upload';
      fullPath: '/upload';
      preLoaderRoute: typeof UploadRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/preparer': {
      id: '/preparer';
      path: '/preparer';
      fullPath: '/preparer';
      preLoaderRoute: typeof PreparerRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/notification-settings': {
      id: '/notification-settings';
      path: '/notification-settings';
      fullPath: '/notification-settings';
      preLoaderRoute: typeof NotificationSettingsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/dashboard': {
      id: '/dashboard';
      path: '/dashboard';
      fullPath: '/dashboard';
      preLoaderRoute: typeof DashboardRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/contact-info': {
      id: '/contact-info';
      path: '/contact-info';
      fullPath: '/contact-info';
      preLoaderRoute: typeof ContactInfoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/client-select': {
      id: '/client-select';
      path: '/client-select';
      fullPath: '/client-select';
      preLoaderRoute: typeof ClientSelectRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/tax-binders/': {
      id: '/tax-binders/';
      path: '/tax-binders';
      fullPath: '/tax-binders/';
      preLoaderRoute: typeof TaxBindersIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/preparer/': {
      id: '/preparer/';
      path: '/';
      fullPath: '/preparer/';
      preLoaderRoute: typeof PreparerIndexRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/binders/': {
      id: '/binders/';
      path: '/binders';
      fullPath: '/binders/';
      preLoaderRoute: typeof BindersIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/upload_/$id': {
      id: '/upload_/$id';
      path: '/upload/$id';
      fullPath: '/upload/$id';
      preLoaderRoute: typeof UploadIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/tax-binders/$binderId': {
      id: '/tax-binders/$binderId';
      path: '/tax-binders/$binderId';
      fullPath: '/tax-binders/$binderId';
      preLoaderRoute: typeof TaxBindersBinderIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/shared-document/$token': {
      id: '/shared-document/$token';
      path: '/shared-document/$token';
      fullPath: '/shared-document/$token';
      preLoaderRoute: typeof SharedDocumentTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/preparer/users': {
      id: '/preparer/users';
      path: '/users';
      fullPath: '/preparer/users';
      preLoaderRoute: typeof PreparerUsersRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/notification-settings': {
      id: '/preparer/notification-settings';
      path: '/notification-settings';
      fullPath: '/preparer/notification-settings';
      preLoaderRoute: typeof PreparerNotificationSettingsRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/login': {
      id: '/preparer/login';
      path: '/login';
      fullPath: '/preparer/login';
      preLoaderRoute: typeof PreparerLoginRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/clients': {
      id: '/preparer/clients';
      path: '/clients';
      fullPath: '/preparer/clients';
      preLoaderRoute: typeof PreparerClientsRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/audit-logs': {
      id: '/preparer/audit-logs';
      path: '/audit-logs';
      fullPath: '/preparer/audit-logs';
      preLoaderRoute: typeof PreparerAuditLogsRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/audit-dashboard': {
      id: '/preparer/audit-dashboard';
      path: '/audit-dashboard';
      fullPath: '/preparer/audit-dashboard';
      preLoaderRoute: typeof PreparerAuditDashboardRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/admin-dashboard': {
      id: '/preparer/admin-dashboard';
      path: '/admin-dashboard';
      fullPath: '/preparer/admin-dashboard';
      preLoaderRoute: typeof PreparerAdminDashboardRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/binders/$': {
      id: '/binders/$';
      path: '/binders/$';
      fullPath: '/binders/$';
      preLoaderRoute: typeof BindersSplatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/tax-binders/$binderId/': {
      id: '/tax-binders/$binderId/';
      path: '/';
      fullPath: '/tax-binders/$binderId/';
      preLoaderRoute: typeof TaxBindersBinderIdIndexRouteImport;
      parentRoute: typeof TaxBindersBinderIdRoute;
    };
    '/preparer/users/': {
      id: '/preparer/users/';
      path: '/';
      fullPath: '/preparer/users/';
      preLoaderRoute: typeof PreparerUsersIndexRouteImport;
      parentRoute: typeof PreparerUsersRoute;
    };
    '/preparer/tax-binders/': {
      id: '/preparer/tax-binders/';
      path: '/tax-binders';
      fullPath: '/preparer/tax-binders/';
      preLoaderRoute: typeof PreparerTaxBindersIndexRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/signature-templates/': {
      id: '/preparer/signature-templates/';
      path: '/signature-templates';
      fullPath: '/preparer/signature-templates/';
      preLoaderRoute: typeof PreparerSignatureTemplatesIndexRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/sent-documents/': {
      id: '/preparer/sent-documents/';
      path: '/sent-documents';
      fullPath: '/preparer/sent-documents/';
      preLoaderRoute: typeof PreparerSentDocumentsIndexRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/notifications/': {
      id: '/preparer/notifications/';
      path: '/notifications';
      fullPath: '/preparer/notifications/';
      preLoaderRoute: typeof PreparerNotificationsIndexRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/clients/': {
      id: '/preparer/clients/';
      path: '/';
      fullPath: '/preparer/clients/';
      preLoaderRoute: typeof PreparerClientsIndexRouteImport;
      parentRoute: typeof PreparerClientsRoute;
    };
    '/preparer/binders/': {
      id: '/preparer/binders/';
      path: '/binders';
      fullPath: '/preparer/binders/';
      preLoaderRoute: typeof PreparerBindersIndexRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/audit-binders/': {
      id: '/preparer/audit-binders/';
      path: '/audit-binders';
      fullPath: '/preparer/audit-binders/';
      preLoaderRoute: typeof PreparerAuditBindersIndexRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/access-requests/': {
      id: '/preparer/access-requests/';
      path: '/access-requests';
      fullPath: '/preparer/access-requests/';
      preLoaderRoute: typeof PreparerAccessRequestsIndexRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/audit-binders/$binderId/': {
      id: '/audit-binders/$binderId/';
      path: '/audit-binders/$binderId';
      fullPath: '/audit-binders/$binderId/';
      preLoaderRoute: typeof AuditBindersBinderIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/tax-binders/$binderId/sign-returns': {
      id: '/tax-binders/$binderId/sign-returns';
      path: '/sign-returns';
      fullPath: '/tax-binders/$binderId/sign-returns';
      preLoaderRoute: typeof TaxBindersBinderIdSignReturnsRouteImport;
      parentRoute: typeof TaxBindersBinderIdRoute;
    };
    '/tax-binders/$binderId/returns': {
      id: '/tax-binders/$binderId/returns';
      path: '/returns';
      fullPath: '/tax-binders/$binderId/returns';
      preLoaderRoute: typeof TaxBindersBinderIdReturnsRouteImport;
      parentRoute: typeof TaxBindersBinderIdRoute;
    };
    '/tax-binders/$binderId/questionnaire': {
      id: '/tax-binders/$binderId/questionnaire';
      path: '/questionnaire';
      fullPath: '/tax-binders/$binderId/questionnaire';
      preLoaderRoute: typeof TaxBindersBinderIdQuestionnaireRouteImport;
      parentRoute: typeof TaxBindersBinderIdRoute;
    };
    '/tax-binders/$binderId/engagement-letter': {
      id: '/tax-binders/$binderId/engagement-letter';
      path: '/engagement-letter';
      fullPath: '/tax-binders/$binderId/engagement-letter';
      preLoaderRoute: typeof TaxBindersBinderIdEngagementLetterRouteImport;
      parentRoute: typeof TaxBindersBinderIdRoute;
    };
    '/tax-binders/$binderId/efile-authorization': {
      id: '/tax-binders/$binderId/efile-authorization';
      path: '/efile-authorization';
      fullPath: '/tax-binders/$binderId/efile-authorization';
      preLoaderRoute: typeof TaxBindersBinderIdEfileAuthorizationRouteImport;
      parentRoute: typeof TaxBindersBinderIdRoute;
    };
    '/tax-binders/$binderId/documents': {
      id: '/tax-binders/$binderId/documents';
      path: '/documents';
      fullPath: '/tax-binders/$binderId/documents';
      preLoaderRoute: typeof TaxBindersBinderIdDocumentsRouteImport;
      parentRoute: typeof TaxBindersBinderIdRoute;
    };
    '/tax-binders/$binderId/communications': {
      id: '/tax-binders/$binderId/communications';
      path: '/communications';
      fullPath: '/tax-binders/$binderId/communications';
      preLoaderRoute: typeof TaxBindersBinderIdCommunicationsRouteImport;
      parentRoute: typeof TaxBindersBinderIdRoute;
    };
    '/preparer/users/$userId': {
      id: '/preparer/users/$userId';
      path: '/$userId';
      fullPath: '/preparer/users/$userId';
      preLoaderRoute: typeof PreparerUsersUserIdRouteImport;
      parentRoute: typeof PreparerUsersRoute;
    };
    '/preparer/tax-binders/$binderId': {
      id: '/preparer/tax-binders/$binderId';
      path: '/tax-binders/$binderId';
      fullPath: '/preparer/tax-binders/$binderId';
      preLoaderRoute: typeof PreparerTaxBindersBinderIdRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/clients/$clientId': {
      id: '/preparer/clients/$clientId';
      path: '/$clientId';
      fullPath: '/preparer/clients/$clientId';
      preLoaderRoute: typeof PreparerClientsClientIdRouteImport;
      parentRoute: typeof PreparerClientsRoute;
    };
    '/preparer/binders/$': {
      id: '/preparer/binders/$';
      path: '/binders/$';
      fullPath: '/preparer/binders/$';
      preLoaderRoute: typeof PreparerBindersSplatRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/audit-binders/$binderId': {
      id: '/preparer/audit-binders/$binderId';
      path: '/audit-binders/$binderId';
      fullPath: '/preparer/audit-binders/$binderId';
      preLoaderRoute: typeof PreparerAuditBindersBinderIdRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/auth/sso/callback': {
      id: '/auth/sso/callback';
      path: '/auth/sso/callback';
      fullPath: '/auth/sso/callback';
      preLoaderRoute: typeof AuthSsoCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/preparer/tax-binders/$binderId/audit-logs': {
      id: '/preparer/tax-binders/$binderId/audit-logs';
      path: '/audit-logs';
      fullPath: '/preparer/tax-binders/$binderId/audit-logs';
      preLoaderRoute: typeof PreparerTaxBindersBinderIdAuditLogsRouteImport;
      parentRoute: typeof PreparerTaxBindersBinderIdRoute;
    };
    '/preparer/signature-templates/preview/$templateId': {
      id: '/preparer/signature-templates/preview/$templateId';
      path: '/signature-templates/preview/$templateId';
      fullPath: '/preparer/signature-templates/preview/$templateId';
      preLoaderRoute: typeof PreparerSignatureTemplatesPreviewTemplateIdRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/signature-templates/edit/$templateId': {
      id: '/preparer/signature-templates/edit/$templateId';
      path: '/signature-templates/edit/$templateId';
      fullPath: '/preparer/signature-templates/edit/$templateId';
      preLoaderRoute: typeof PreparerSignatureTemplatesEditTemplateIdRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/preparer/clients/$clientId/audit-logs': {
      id: '/preparer/clients/$clientId/audit-logs';
      path: '/audit-logs';
      fullPath: '/preparer/clients/$clientId/audit-logs';
      preLoaderRoute: typeof PreparerClientsClientIdAuditLogsRouteImport;
      parentRoute: typeof PreparerClientsClientIdRoute;
    };
    '/preparer/binder/$binderId/audit-logs': {
      id: '/preparer/binder/$binderId/audit-logs';
      path: '/binder/$binderId/audit-logs';
      fullPath: '/preparer/binder/$binderId/audit-logs';
      preLoaderRoute: typeof PreparerBinderBinderIdAuditLogsRouteImport;
      parentRoute: typeof PreparerRoute;
    };
    '/audit-binders/$binderId/items/$itemId': {
      id: '/audit-binders/$binderId/items/$itemId';
      path: '/audit-binders/$binderId/items/$itemId';
      fullPath: '/audit-binders/$binderId/items/$itemId';
      preLoaderRoute: typeof AuditBindersBinderIdItemsItemIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/preparer/tax-binders/$binderId/document-request/$requestId': {
      id: '/preparer/tax-binders/$binderId/document-request/$requestId';
      path: '/document-request/$requestId';
      fullPath: '/preparer/tax-binders/$binderId/document-request/$requestId';
      preLoaderRoute: typeof PreparerTaxBindersBinderIdDocumentRequestRequestIdRouteImport;
      parentRoute: typeof PreparerTaxBindersBinderIdRoute;
    };
  }
}

interface PreparerClientsClientIdRouteChildren {
  PreparerClientsClientIdAuditLogsRoute: typeof PreparerClientsClientIdAuditLogsRoute;
}

const PreparerClientsClientIdRouteChildren: PreparerClientsClientIdRouteChildren =
  {
    PreparerClientsClientIdAuditLogsRoute:
      PreparerClientsClientIdAuditLogsRoute,
  };

const PreparerClientsClientIdRouteWithChildren =
  PreparerClientsClientIdRoute._addFileChildren(
    PreparerClientsClientIdRouteChildren,
  );

interface PreparerClientsRouteChildren {
  PreparerClientsClientIdRoute: typeof PreparerClientsClientIdRouteWithChildren;
  PreparerClientsIndexRoute: typeof PreparerClientsIndexRoute;
}

const PreparerClientsRouteChildren: PreparerClientsRouteChildren = {
  PreparerClientsClientIdRoute: PreparerClientsClientIdRouteWithChildren,
  PreparerClientsIndexRoute: PreparerClientsIndexRoute,
};

const PreparerClientsRouteWithChildren = PreparerClientsRoute._addFileChildren(
  PreparerClientsRouteChildren,
);

interface PreparerUsersRouteChildren {
  PreparerUsersUserIdRoute: typeof PreparerUsersUserIdRoute;
  PreparerUsersIndexRoute: typeof PreparerUsersIndexRoute;
}

const PreparerUsersRouteChildren: PreparerUsersRouteChildren = {
  PreparerUsersUserIdRoute: PreparerUsersUserIdRoute,
  PreparerUsersIndexRoute: PreparerUsersIndexRoute,
};

const PreparerUsersRouteWithChildren = PreparerUsersRoute._addFileChildren(
  PreparerUsersRouteChildren,
);

interface PreparerTaxBindersBinderIdRouteChildren {
  PreparerTaxBindersBinderIdAuditLogsRoute: typeof PreparerTaxBindersBinderIdAuditLogsRoute;
  PreparerTaxBindersBinderIdDocumentRequestRequestIdRoute: typeof PreparerTaxBindersBinderIdDocumentRequestRequestIdRoute;
}

const PreparerTaxBindersBinderIdRouteChildren: PreparerTaxBindersBinderIdRouteChildren =
  {
    PreparerTaxBindersBinderIdAuditLogsRoute:
      PreparerTaxBindersBinderIdAuditLogsRoute,
    PreparerTaxBindersBinderIdDocumentRequestRequestIdRoute:
      PreparerTaxBindersBinderIdDocumentRequestRequestIdRoute,
  };

const PreparerTaxBindersBinderIdRouteWithChildren =
  PreparerTaxBindersBinderIdRoute._addFileChildren(
    PreparerTaxBindersBinderIdRouteChildren,
  );

interface PreparerRouteChildren {
  PreparerAdminDashboardRoute: typeof PreparerAdminDashboardRoute;
  PreparerAuditDashboardRoute: typeof PreparerAuditDashboardRoute;
  PreparerAuditLogsRoute: typeof PreparerAuditLogsRoute;
  PreparerClientsRoute: typeof PreparerClientsRouteWithChildren;
  PreparerLoginRoute: typeof PreparerLoginRoute;
  PreparerNotificationSettingsRoute: typeof PreparerNotificationSettingsRoute;
  PreparerUsersRoute: typeof PreparerUsersRouteWithChildren;
  PreparerIndexRoute: typeof PreparerIndexRoute;
  PreparerAuditBindersBinderIdRoute: typeof PreparerAuditBindersBinderIdRoute;
  PreparerBindersSplatRoute: typeof PreparerBindersSplatRoute;
  PreparerTaxBindersBinderIdRoute: typeof PreparerTaxBindersBinderIdRouteWithChildren;
  PreparerAccessRequestsIndexRoute: typeof PreparerAccessRequestsIndexRoute;
  PreparerAuditBindersIndexRoute: typeof PreparerAuditBindersIndexRoute;
  PreparerBindersIndexRoute: typeof PreparerBindersIndexRoute;
  PreparerNotificationsIndexRoute: typeof PreparerNotificationsIndexRoute;
  PreparerSentDocumentsIndexRoute: typeof PreparerSentDocumentsIndexRoute;
  PreparerSignatureTemplatesIndexRoute: typeof PreparerSignatureTemplatesIndexRoute;
  PreparerTaxBindersIndexRoute: typeof PreparerTaxBindersIndexRoute;
  PreparerBinderBinderIdAuditLogsRoute: typeof PreparerBinderBinderIdAuditLogsRoute;
  PreparerSignatureTemplatesEditTemplateIdRoute: typeof PreparerSignatureTemplatesEditTemplateIdRoute;
  PreparerSignatureTemplatesPreviewTemplateIdRoute: typeof PreparerSignatureTemplatesPreviewTemplateIdRoute;
}

const PreparerRouteChildren: PreparerRouteChildren = {
  PreparerAdminDashboardRoute: PreparerAdminDashboardRoute,
  PreparerAuditDashboardRoute: PreparerAuditDashboardRoute,
  PreparerAuditLogsRoute: PreparerAuditLogsRoute,
  PreparerClientsRoute: PreparerClientsRouteWithChildren,
  PreparerLoginRoute: PreparerLoginRoute,
  PreparerNotificationSettingsRoute: PreparerNotificationSettingsRoute,
  PreparerUsersRoute: PreparerUsersRouteWithChildren,
  PreparerIndexRoute: PreparerIndexRoute,
  PreparerAuditBindersBinderIdRoute: PreparerAuditBindersBinderIdRoute,
  PreparerBindersSplatRoute: PreparerBindersSplatRoute,
  PreparerTaxBindersBinderIdRoute: PreparerTaxBindersBinderIdRouteWithChildren,
  PreparerAccessRequestsIndexRoute: PreparerAccessRequestsIndexRoute,
  PreparerAuditBindersIndexRoute: PreparerAuditBindersIndexRoute,
  PreparerBindersIndexRoute: PreparerBindersIndexRoute,
  PreparerNotificationsIndexRoute: PreparerNotificationsIndexRoute,
  PreparerSentDocumentsIndexRoute: PreparerSentDocumentsIndexRoute,
  PreparerSignatureTemplatesIndexRoute: PreparerSignatureTemplatesIndexRoute,
  PreparerTaxBindersIndexRoute: PreparerTaxBindersIndexRoute,
  PreparerBinderBinderIdAuditLogsRoute: PreparerBinderBinderIdAuditLogsRoute,
  PreparerSignatureTemplatesEditTemplateIdRoute:
    PreparerSignatureTemplatesEditTemplateIdRoute,
  PreparerSignatureTemplatesPreviewTemplateIdRoute:
    PreparerSignatureTemplatesPreviewTemplateIdRoute,
};

const PreparerRouteWithChildren = PreparerRoute._addFileChildren(
  PreparerRouteChildren,
);

interface TaxBindersBinderIdRouteChildren {
  TaxBindersBinderIdCommunicationsRoute: typeof TaxBindersBinderIdCommunicationsRoute;
  TaxBindersBinderIdDocumentsRoute: typeof TaxBindersBinderIdDocumentsRoute;
  TaxBindersBinderIdEfileAuthorizationRoute: typeof TaxBindersBinderIdEfileAuthorizationRoute;
  TaxBindersBinderIdEngagementLetterRoute: typeof TaxBindersBinderIdEngagementLetterRoute;
  TaxBindersBinderIdQuestionnaireRoute: typeof TaxBindersBinderIdQuestionnaireRoute;
  TaxBindersBinderIdReturnsRoute: typeof TaxBindersBinderIdReturnsRoute;
  TaxBindersBinderIdSignReturnsRoute: typeof TaxBindersBinderIdSignReturnsRoute;
  TaxBindersBinderIdIndexRoute: typeof TaxBindersBinderIdIndexRoute;
}

const TaxBindersBinderIdRouteChildren: TaxBindersBinderIdRouteChildren = {
  TaxBindersBinderIdCommunicationsRoute: TaxBindersBinderIdCommunicationsRoute,
  TaxBindersBinderIdDocumentsRoute: TaxBindersBinderIdDocumentsRoute,
  TaxBindersBinderIdEfileAuthorizationRoute:
    TaxBindersBinderIdEfileAuthorizationRoute,
  TaxBindersBinderIdEngagementLetterRoute:
    TaxBindersBinderIdEngagementLetterRoute,
  TaxBindersBinderIdQuestionnaireRoute: TaxBindersBinderIdQuestionnaireRoute,
  TaxBindersBinderIdReturnsRoute: TaxBindersBinderIdReturnsRoute,
  TaxBindersBinderIdSignReturnsRoute: TaxBindersBinderIdSignReturnsRoute,
  TaxBindersBinderIdIndexRoute: TaxBindersBinderIdIndexRoute,
};

const TaxBindersBinderIdRouteWithChildren =
  TaxBindersBinderIdRoute._addFileChildren(TaxBindersBinderIdRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ClientSelectRoute: ClientSelectRoute,
  ContactInfoRoute: ContactInfoRoute,
  DashboardRoute: DashboardRoute,
  LoginRoute: LoginRoute,
  NotificationSettingsRoute: NotificationSettingsRoute,
  PreparerRoute: PreparerRouteWithChildren,
  UploadRoute: UploadRoute,
  UserSettingsRoute: UserSettingsRoute,
  BindersSplatRoute: BindersSplatRoute,
  SharedDocumentTokenRoute: SharedDocumentTokenRoute,
  TaxBindersBinderIdRoute: TaxBindersBinderIdRouteWithChildren,
  UploadIdRoute: UploadIdRoute,
  BindersIndexRoute: BindersIndexRoute,
  TaxBindersIndexRoute: TaxBindersIndexRoute,
  AuthSsoCallbackRoute: AuthSsoCallbackRoute,
  AuditBindersBinderIdIndexRoute: AuditBindersBinderIdIndexRoute,
  AuditBindersBinderIdItemsItemIdRoute: AuditBindersBinderIdItemsItemIdRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
